import React, { useCallback } from 'react';
import { Form, Formik } from 'formik';
import PropTypes from 'prop-types';
import i18n from 'i18next';
import useStyles from './ClientCreationForm.styles';
import HeaderActions from './header/HeaderActions';
import TextField from '../../../common/components/fields/TextField';
import clientCreationFormSchema from '../../schemas/clientCreationFormSchema';

const defaultInitialValues = {
  name: '',
  description: '',
};

const ClientCreationForm = ({ onBackClick, onSubmit }) => {
  const classes = useStyles();

  const handleSubmit = useCallback(
    (values, actions) => {
      onSubmit(values, actions);
      actions.setSubmitting(false);
    },
    [onSubmit]
  );

  return (
    <Formik initialValues={defaultInitialValues} validationSchema={clientCreationFormSchema} onSubmit={handleSubmit}>
      {() => (
        <Form>
          <div className={classes.header}>
            <div className={classes.label}>
              <TextField name="name" placeholder={i18n.t('client.form.clientName')} classes={{ root: classes.textField }} inputClassName={classes.textField} />
            </div>
            <HeaderActions onBackClick={onBackClick} />
          </div>

          <TextField className={classes.container} name="description" placeholder={i18n.t('client.form.enterDescription')} />
        </Form>
      )}
    </Formik>
  );
};

ClientCreationForm.propTypes = {
  onBackClick: PropTypes.func,
  onSubmit: PropTypes.func.isRequired,
};

ClientCreationForm.defaultProps = {
  onBackClick: undefined,
};
export default ClientCreationForm;
